<template>
  <section class="map-page fullheight">
    <cover v-if="showCover"></cover>
    <building-info></building-info>
  </section>
</template>

<script>
import Cover from '@/components/Cover.vue';
import BuildingInfo from '@/components/BuildingInfo.vue';

export default {
  name: 'MapPage',
  components: {
    Cover,
    BuildingInfo,
  },
  data() {
    return {
      showCover: true,
    };
  },
  watch: {
    $route(n) {
      if (n.params.id) {
        this.showCover = false;
      } else {
        this.showCover = true;
      }
    },
  },
  created() {
    if (this.$route.params.id) {
      this.showCover = false;
    } else {
      this.showCover = true;
    }
  },
};
</script>

<style scoped>
.map-page {
  width: 100%;
  min-width: 0;
}
</style>
